<template>
  <div class="receipt">
    <div class="receipt-container">
      <div class="receipt__column" style="flex: 1 1 auto">
        <p class="card-title">Supplements</p>
        <v-card>
          <v-card-text>
            <Table
              :headers="headers"
              :items="regularProductsItems"
              :all-selected.sync="allSelected"
              hideDefaultFooter
            >
              <template v-slot:body>
                <template v-for="item in regularProductsItems">
                  <tr
                    :key="item.id"
                    class="custom-receipt-table__dynamic"
                    :class="{
                      'is-default': item.isDefault
                    }"
                  >
                    <td>
                      <div class="d-flex align-center justify-center">
                        <div class="d-flex">
                          <checkbox :class="{'disabled': ['Completed', 'Closed'].includes(visit.status)}" color="#008C89" :inputValue="item.showOnReceipt" @change="updatePreviewReceipt('regularProducts', item, item.resultSupplementProductId, $event), item.showOnReceipt=$event"></checkbox>
                        </div>
                      </div>
                    </td>
                    <td class="pa-0">
                      <div class="d-flex align-center justify-center">
                        <div class="d-flex">
                          <span>{{item.productNumber}}</span>
                        </div>
                      </div>
                    </td>
                    <td class="pa-0">
                      <div class="d-flex align-center justify-center">
                        <div class="d-flex">
                          <span>{{item.quantity}}</span>
                        </div>
                      </div>
                    </td>
                    <td style="font-weight: 600; padding: 0 4px 0 20px">
                      <div class="d-flex align-center justify-start">
                        <div class="d-flex">
                          <span>{{item.productName}}</span>
                        </div>
                      </div>
                    </td>
                    <td style="padding: 0 4px 0 20px">
                      <div class="d-flex align-center justify-start">
                        <div class="d-flex drop-ship" @click="openReceiptView(item)">
                          <span v-if="item.pastReceipt" style="cursor: pointer; color: #537CFF;"># {{item.pastReceipt.receiptNumber}} {{item.pastReceipt.orderMethodName}}</span>
                          <span v-else>-</span>
                        </div>
                      </div>
                    </td>
                    <td style="padding: 0 10px">
                      <div class="d-flex align-center justify-center">
                        <div class="d-flex">
                          <span>{{item.size}}</span>
                        </div>
                      </div>
                    </td>
                    <td class="pa-0">
                      <div class="d-flex align-center justify-center">
                        <div class="d-flex">
                          <span>${{item.unitPrice.toFixed(2)}}</span>
                        </div>
                      </div>
                    </td>
                    <td class="pa-0">
                      <div class="d-flex align-center justify-center">
                        <div class="d-flex">
                          <span>${{item.totalCost.toFixed(2)}}</span>
                        </div>
                      </div>
                    </td>
                  </tr>
                </template>
              </template>
            </Table>
            <Table
              class="table-total-cost"
              hideDefaultFooter>

              <template v-slot:body>
                <tr class="custom-receipt-table__no-dynamic" v-if="receiptPreview">
                  <td>
                    <span style="color: #718096; font-size: 12px; font-weight: 600">
                      Total
                    </span>
                  </td>
                  <td class="total-row">
                    <div class="d-flex">
                      <div class="total-row__col">
                        <span style="color: #718096">Daily:</span>
                        <span style="color: #425466">
                          {{receiptPreview.totalDailyPrice !== 0 ? '$' + receiptPreview.totalDailyPrice.toFixed(2) : ''}}
                        </span>
                      </div>
                      <div class="total-row__col">
                        <span style="color: #718096">Weekly:</span>
                        <span style="color: #425466">
                          {{receiptPreview.totalWeeklyPrice !== 0 ? '$' + receiptPreview.totalWeeklyPrice.toFixed(2) : ''}}
                        </span>
                      </div>
                      <div class="total-row__col">
                        <span style="color: #718096">Monthly:</span>
                        <span style="color: #425466">
                          {{receiptPreview.totalMonthlyPrice !== 0 ? '$' + receiptPreview.totalMonthlyPrice.toFixed(2) : ''}}
                        </span>
                      </div>
                    </div>
                  </td>
                  <td class="total-row">
                    <span style="color: #1A202C; font-size: 15px">
                      {{receiptPreview.totalProductsPrice !== 0 ? '$' + receiptPreview.totalProductsPrice.toFixed(2) : '-'}}
                    </span>
                  </td>
                </tr>
              </template>

            </Table>
          </v-card-text>
        </v-card>
        <div class="d-flex align-center justify-space-between" style="margin-top: 23px">
          <p class="card-title" style="margin-bottom: 0">Non-Supplements</p>
          <div class="main-row" style="column-gap: 0.3rem; justify-content: space-between">
            <Button v-if="['InProtocol', 'NeedProduct', 'ProtocolEnding', 'InProgress', 'Reviewed', 'SurveyDue', 'SurveySent', 'InActive', 'NeedSurvey', 'NeedReeval', 'NeedReview'].includes(visit.status)"
                    class="btn-white"
                    @click="onAddProduct">
              <PlusGreenIcon />
              Product
            </Button><!--v-if="['InProtocol', 'NeedProduct'].includes(visit.status)"-->
          </div>
        </div>
        <v-card v-if="clinicProductsItems && clinicProductsItems.length > 0" style="margin-top: 12px; border-top-right-radius: 0 !important; border-top-left-radius: 0 !important;">
          <v-card-text>
            <Table
              :headers="headersClinicProducts"
              class="table-clinic-products"
              hideDefaultFooter>
              <template v-slot:body>
                <template v-for="item in clinicProductsItems">
                  <tr
                    :key="item.id"
                    class="custom-receipt-table__dynamic"
                    :class="{
                      'is-default': item.isDefault
                    }"
                  >
                    <td>
                      <div class="d-flex align-center justify-center">
                        <div class="d-flex align-center">
                          <checkbox :class="{'disabled': ['Completed', 'Closed'].includes(visit.status)}" color="#008C89" :inputValue="item.showOnReceipt" @change="updatePreviewReceipt('clinicProducts', item, item.resultSupplementProductId, $event), item.showOnReceipt=$event"></checkbox>
                          <v-icon v-if="!item.isDefault && item.pastReceipt" style="margin-top: -2px;" @click="deleteClinicProduct(item.resultSupplementProductId)">mdi-trash-can-outline</v-icon>
                        </div>
                      </div>
                    </td>
                    <td class="pa-0">
                      <div class="d-flex align-center justify-center">
                        <div class="d-flex">
                          <span>{{item.productNumber}}</span>
                        </div>
                      </div>
                    </td>
                    <td class="pa-0">
                      <div class="d-flex align-center justify-center">
                        <div class="d-flex align-center justify-center">
                          <span>{{item.quantity}}</span>
                          <div class="d-flex flex-column">
                            <Img style="cursor: pointer" @click.native="updateQuantityBottles(1, item, item.resultSupplementProductId)" :src="getImgWithExt(['icons', 'chevron-up', 'svg'])" width="24px" />
                            <Img style="transform: rotate(-180deg); cursor: pointer" v-show="item.quantity > 1" @click.native="updateQuantityBottles(-1, item, item.resultSupplementProductId)" :src="getImgWithExt(['icons', 'chevron-up', 'svg'])" width="24px" />
                          </div>
                        </div>
                      </div>
                    </td>
                    <td style="font-weight: 600; padding: 0 4px 0 20px">
                      <div class="d-flex align-center justify-start">
                        <div class="d-flex">
                          <span>{{item.productName}}</span>
                        </div>
                      </div>
                    </td>
                    <td style="padding: 0 4px 0 20px">
                      <div class="d-flex align-center justify-start">
                        <div class="d-flex drop-ship" @click="openReceiptView(item)">
                          <span v-if="item.pastReceipt" style="cursor: pointer; color: #537CFF;"># {{item.pastReceipt.receiptNumber}} {{item.pastReceipt.orderMethodName}}</span>
                          <span v-else>-</span>
                        </div>
                      </div>
                    </td>
                    <td class="pa-0">
                      <div class="d-flex align-center justify-center">
                        <div class="d-flex">
                          <span>${{item.unitPrice.toFixed(2)}}</span>
                        </div>
                      </div>
                    </td>
                    <td class="pa-0">
                      <div class="d-flex align-center justify-center">
                        <div class="d-flex">
                          <span>${{item.totalCost.toFixed(2)}}</span>
                        </div>
                      </div>
                    </td>
                  </tr>
                </template>
              </template>
            </Table>
            <Table
              class="table-total-cost"
              hideDefaultFooter>
              <template v-slot:body>
                <tr class="custom-receipt-table__no-dynamic" v-if="receiptPreview">
                  <td>
                    <span style="color: #718096; font-size: 12px; font-weight: 600">
                      Total
                    </span>
                  </td>
                  <td class="total-row">
                    <span style="color: #1A202C; font-size: 15px">
                      {{receiptPreview.totalClinicProductsPrice !== 0 ? '$' + receiptPreview.totalClinicProductsPrice.toFixed(2) : ''}}
                    </span>
                  </td>
                </tr>
              </template>

            </Table>
          </v-card-text>
        </v-card>
      </div>
      <div class="receipt__column column-right" style="flex: 0 0 350px;">
        <v-card class="options-adn-fees">
          <div class="main-row align-end" style="margin-bottom: 30px; column-gap: 16px">
            <Img class="logo" :src="getImgWithExt(['icons', 'money2', 'svg'])" />
            <p class="info-title">Options and fees</p>
          </div>
          <v-card-text>
            <div class="main-row justify-space-between" v-if="receiptPreview && receiptPreview.salesTaxValue" style="margin-bottom: 10px">
              <span style="color: #1A202C">Sales Tax</span>
              <div class="input-setting">
                <span>${{receiptPreview.salesTaxValue.toFixed(2)}}</span>
              </div>
            </div>
            <div class="main-row justify-space-between" style="margin-bottom: 10px">
              <span style="color: #1A202C">Shipping Fee</span>
              <div class="input-setting">
                <span style="font-size: 18px; font-weight: 400; color: #1A202C">${{shippingFee}}</span>
              </div>
            </div>
            <div class="main-row justify-space-between" v-if="receiptPreview" style="margin-bottom: 10px">
              <span style="color: #1A202C">Total price</span>
              <div class="input-setting">
                <span style="font-size: 18px; font-weight: 600; color: #1A202C">
                  {{receiptPreview.totalPrice !== 0 ? '$' + receiptPreview.totalPrice.toFixed(2) : ''}}</span>
              </div>
            </div>
            <div class="main-row justify-space-between" style="margin-bottom: 10px">
              <span style="color: #1A202C">Min. Ship. Fee</span>
              <div class="input-setting">
                <span style="font-size: 15px; font-weight: 400; color: #718096">${{minimumAmountFreeShip}}</span>
              </div>
            </div>
            <div class="main-row justify-space-between">
              <span style="color: #1A202C">Price Modifier</span>
              <div class="input-setting">
                <span style="font-size: 15px; font-weight: 400; color: #718096">{{priceModifier}}%</span>
              </div>
            </div>
          </v-card-text>
          <Button btn-bg="dark-green"
                  @click="onGenerateReceipts"
                  :styles="{ 'width': '100%', 'height': '48px', 'border-radius': '16px', 'border': '1px solid #008C89', 'margin-top': '14px' }">
            <span style="color: #FFFFFF; font-size: 14px; letter-spacing: 0">Generate {{orderTypeName}} Invoice</span>
          </Button>
        </v-card>
        <v-card class="all-receipts">
          <div class="all-receipts__top">
            <Img :src="getImgWithExt(['icons', 'bottle', 'svg'])" />
            <p class="info-title">Invoices</p>
            <span v-if="listReceipts && listReceipts.length">Date</span>
          </div>

          <template v-if="listReceipts && listReceipts.length">
            <div class="receipt-list">
              <div v-for="item in listReceipts" :key="item.id" class="receipt-item">
                <div class="receipt-item__content" @click="openReceiptView(item)">
                  <div class="d-flex align-center" style="column-gap: 15px;">
                    <Img :src="getImgWithExt(['icons', 'list', 'svg'])" alt="list"/>
                    <span class="receipt-number-name"># {{item.receiptNumber}} {{item.orderMethodName}}</span>
                  </div>

                  <div class="receipt-details">
                    <span>{{$moment(item.date).format('MM/DD')}}</span>
                    <Img :src="getImgWithExt(['icons', 'chevron-right', 'svg'])" alt="right"/>
                  </div>
                </div>
                <Img @click.native="handlerRemoveReceipt(item.id)" :src="getImgWithExt(['icons', 'delete-icon', 'svg'])" alt="delete receipt" style="cursor: pointer"/>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="empty-receipts-message">
              select the required supplements and generate an invoice
            </div>
          </template>
        </v-card>
        <div class="main-row mt-2" v-if="!['InProtocol', 'NeedProduct'].includes(visit.status)"></div>
      </div>
    </div>
    <receipt-view-form v-if="dialogs.receiptViewForm.isOpen" @showPopup="showPopup" />
    <product v-if="dialogs.dialogShowProduct.isOpen"></product>
    <confirm v-if="dialogs.confirm.isOpen" @showPopup="handlerConfirm" />
    <div class="custom-alert">
      <v-alert
        :color="alertColor"
        dismissible
        :type="alertType"
        v-model="alertIsOpen"
      >
        <span style="font-size: 14px;">{{popupMessage}}</span>
      </v-alert>
    </div>
    <div v-if="loading" class="loading d-flex justify-center px-2 py-2 align-center">
      <v-progress-circular
        indeterminate
        color="#008C89"
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import Table from '@/components/elements/Table'
import checkbox from '@/components/elements/checkbox'
import Number from '@/mixins/Number'
import Image from '@/mixins/Image'
import Img from '@/components/elements/Img'
import Button from '@/components/elements/Button'
import Input from '@/components/elements/Input'
import Product from '@/components/layouts/dialogs/product.vue'
import { trackEvent } from '@/utils/analytics'
import PlusGreenIcon from '@/assets/icons/components/plus-sm-green.svg'

export default {
  name: 'receipt',
  mixins: [Number, Image],
  props: {
    orderMethod: {
      type: Object
    },
    // calcMethod: {
    //   type: Object
    // },
    isUpdateDaysSupply: {
      type: Boolean,
      default: false
    },
    isUpdateVisit: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Product,
    Table,
    checkbox,
    Img,
    Button,
    Input,
    PlusGreenIcon,
    ReceiptViewForm: () => import('@/components/layouts/dialogs/receipt-view-form.vue'),
    confirm: () => import('@/components/layouts/dialogs/confirm-dialog.vue')
  },
  data: () => ({
    allSelected: false,
    silentUpdate: false,
    alertIsOpen: false,
    popupMessage: null,
    alertType: 'info',
    alertColor: '#7ac1fb',
    checkedProductIds: [],
    regularProducts: [],
    clinicProducts: [],
    visitFee: 0,
    otherFee: 0,
    minimumAmountFreeShip: 0,
    salesTax: 0,
    shippingFee: 0,
    priceModifier: 0,
    loading: true
  }),
  methods: {
    ...mapActions('receipts', ['getReceipts', 'createReceiptPreview', 'generateReceipts', 'deleteReceipt']),
    ...mapActions('results', ['updateSupplementProduct', 'removeSupplementProduct', 'getResults']),
    ...mapMutations('dialogs', ['TOGGLE_DIALOG']),
    showPopup ({ message, type, color }) {
      this.alertType = type
      this.alertColor = color
      this.alertIsOpen = true
      this.popupMessage = `${message}`
      this.TOGGLE_DIALOG({ name: 'receiptViewForm', isOpen: false })
      const self = this
      setTimeout(function () {
        self.alertIsOpen = false
      }, 3000)
    },
    handlerConfirm (res) {
      const { id } = this.$route.params
      if (res) {
        this.getReceipts(this.visit.resultId)
        const resultId = this.visit.resultId
        const orderMethodCode = this.orderMethod.code
        // const calcMethodCode = this.calcMethod.code
        const visitFee = this.visitFee
        const otherFee = this.otherFee
        const regularProducts = this.regularProductsItems
        const clinicProducts = this.clinicProductsItems
        this.createReceiptPreview({
          form: {
            visitId: id,
            resultId,
            orderMethodCode,
            // calcMethodCode,
            visitFee,
            otherFee,
            regularProducts: regularProducts,
            clinicProducts: clinicProducts
          }
        })
      }
    },
    async updatePreviewReceipt (key, object, localId, value) {
      let updatedItems = this.regularProductsItems.map(item => {
        if (item.resultSupplementProductId === object.resultSupplementProductId) {
          return {
            ...item,
            showOnReceipt: value
          }
        }
        return item
      })
      const { id } = this.$route.params
      let regularProducts = []
      let clinicProducts = []
      // this.checkedProductIds.push(localId)
      if (key === 'regularProducts') {
        this.regularProductsItems.map(item => {
          regularProducts.push({
            ...item,
            showOnReceipt: item.resultSupplementProductId === object.resultSupplementProductId ? value : item.showOnReceipt})
        })
        clinicProducts = this.clinicProductsItems
      }
      if (key === 'clinicProducts') {
        this.clinicProductsItems.map(item => {
          clinicProducts.push({...item, showOnReceipt: item.resultSupplementProductId === object.resultSupplementProductId ? value : item.showOnReceipt})
        })
        regularProducts = this.regularProductsItems
      }
      const resultId = this.visit.resultId
      const orderMethodCode = this.orderMethod.code
      // const calcMethodCode = this.calcMethod.code
      const visitFee = this.visitFee
      const otherFee = this.otherFee
      const res = await this.createReceiptPreview({
        form: {
          visitId: id,
          resultId,
          orderMethodCode,
          // calcMethodCode,
          visitFee,
          otherFee,
          regularProducts: updatedItems,
          clinicProducts: clinicProducts
        }
      })
      if (res) {
        this.visitFee = this.receiptPreview.visitFee
        this.otherFee = this.receiptPreview.otherFee
        this.minimumAmountFreeShip = this.receiptPreview.minimumAmountFreeShip
        this.salesTax = this.receiptPreview.salesTaxValue
        this.shippingFee = this.receiptPreview.shippingFeeValue
        this.priceModifier = this.receiptPreview.priceModifierPercent
        clinicProducts = []
        regularProducts = []
      }
    },
    async onGenerateReceipts () {
      const { id } = this.$route.params
      const resultId = this.visit.resultId
      const orderMethodCode = this.orderMethod.code
      // const calcMethodCode = this.calcMethod.code
      const visitFee = this.visitFee
      const otherFee = this.otherFee
      this.regularProducts = this.regularProductsItems
      this.clinicProducts = this.clinicProductsItems
      const resGen = await this.generateReceipts({
        form: {
          resultId,
          orderMethodCode,
          // calcMethodCode,
          visitFee,
          otherFee,
          regularProducts: this.regularProducts,
          clinicProducts: this.clinicProducts
        }
      })
      if (resGen) {
        trackEvent(this, 'generate_invoice', 'Invoices', `${resGen.orderMethodName} Invoice was Generated`)

        await this.$store.dispatch('visits/updateTotalInvoices', { totalInvoices: resGen.totalInvoices })

        this.getReceipts(this.visit.resultId)
        const resultId = this.visit.resultId
        const orderMethodCode = this.orderMethod.code
        // const calcMethodCode = this.calcMethod.code
        const visitFee = this.visitFee
        const otherFee = this.otherFee
        const res = await this.createReceiptPreview({
          form: {
            visitId: id,
            resultId,
            orderMethodCode,
            // calcMethodCode,
            visitFee,
            otherFee,
            regularProducts: this.regularProducts,
            clinicProducts: this.clinicProducts
          }
        })
        if (res) {
          this.visitFee = this.receiptPreview.visitFee
          this.otherFee = this.receiptPreview.otherFee
          this.minimumAmountFreeShip = this.receiptPreview.minimumAmountFreeShip
          this.salesTax = this.receiptPreview.salesTaxValue
          this.shippingFee = this.receiptPreview.shippingFeeValue
          this.priceModifier = this.receiptPreview.priceModifierPercent
        }
        this.openReceiptView(resGen)
      }
    },
    async deleteClinicProduct (supplementProductId) {
      const response = await this.removeSupplementProduct({ supplementProductId })
      if (response) {
        this.showPopup({message: 'Clinic product was deleted success!', type: 'info', color: '#7ac1fb'})
        const { id } = this.$route.params
        const resultId = this.visit.resultId
        const orderMethodCode = this.visit.receiptOrderTypeCode
        // const calcMethodCode = this.visit.calcMethodTypeCode
        const visitFee = null
        const otherFee = null
        const res = await this.createReceiptPreview({
          form: {
            visitId: id,
            resultId,
            otherFee,
            orderMethodCode,
            // calcMethodCode,
            visitFee
          }
        })
        if (res) {
          this.visitFee = this.receiptPreview.visitFee
          this.otherFee = this.receiptPreview.otherFee
          this.minimumAmountFreeShip = this.receiptPreview.minimumAmountFreeShip
          this.salesTax = this.receiptPreview.salesTaxValue
          this.shippingFee = this.receiptPreview.shippingFeeValue
          this.priceModifier = this.receiptPreview.priceModifierPercent
          this.$emit('updateOrderMethod', { code: this.receiptPreview.orderType.code, name: this.receiptPreview.orderType.name })
        }
      } else {
        this.$emit('showPopup', { message: 'Occurred some error', type: 'error', color: '#CF4655' })
      }
    },
    onAddProduct () {
      this.TOGGLE_DIALOG({ name: 'dialogShowProduct', isOpen: true, title: 'Select product' })
    },
    async updateQuantityBottles (val, product, resultSupplementProductId) {
      const res = product.quantity + val
      if (res >= 1) {
        const response = await this.updateSupplementProduct({ supplementProductId: resultSupplementProductId, numberOfBottles: res })
        if (response) {
          const { id } = this.$route.params
          const resultId = this.visit.resultId
          const orderMethodCode = this.visit.receiptOrderTypeCode // this.orderMethod.code
          // const calcMethodCode = this.visit.calcMethodTypeCode
          const visitFee = null // this.visitFee
          const otherFee = null // this.otherFee
          const res = await this.createReceiptPreview({
            form: {
              visitId: id,
              resultId,
              otherFee,
              orderMethodCode,
              // calcMethodCode,
              visitFee
            }
          })
          if (res) {
            this.visitFee = this.receiptPreview.visitFee
            this.otherFee = this.receiptPreview.otherFee
            this.minimumAmountFreeShip = this.receiptPreview.minimumAmountFreeShip
            this.salesTax = this.receiptPreview.salesTaxValue
            this.shippingFee = this.receiptPreview.shippingFeeValue
            this.priceModifier = this.receiptPreview.priceModifierPercent
            this.$emit('updateOrderMethod', { code: this.receiptPreview.orderType.code, name: this.receiptPreview.orderType.name })
          }
        }
      }
    },
    handlerRemoveReceipt (id) {
      this.TOGGLE_DIALOG({ name: 'confirm', title: 'Please confirm Delete Invoice', isOpen: true, whose: 'confirmationDeleteReceipt', id, resultId: this.visit.resultId,  action: 'receipts/deleteReceipt', })
    },
    openReceiptView (item) {
      const data = item
      if ('pastReceipt' in item) {
        data.id = item.pastReceipt.id
        data.orderMethodName = item.pastReceipt.orderMethodName
        data.orderMethodCode = item.pastReceipt.orderMethodCode
      }
      this.TOGGLE_DIALOG({ name: 'receiptViewForm', title: `${data.orderMethodName} Invoice`, isOpen: true, data: data })
    }
  },
  async mounted () {
    const { id } = this.$route.params
    this.loading = true
    const resData = await this.getReceipts(this.visit.resultId)
    if (resData) {
      this.loading = false
    }
    const resultId = this.visit.resultId
    // const orderMethodCode = this.visit.receiptOrderTypeCode // this.orderMethod.code


    if (!this.result || !this.result.record) {
      console.warn('Result data not loaded yet')
      return
    }
    const orderMethodCode = this.result.record.orderMethodCode
    // const calcMethodCode = this.visit.calcMethodTypeCode
    const visitFee = null // this.visitFee
    const otherFee = null // this.otherFee
    const res = await this.createReceiptPreview({
      form: {
        visitId: id,
        resultId,
        otherFee,
        orderMethodCode,
        // calcMethodCode,
        visitFee
      }
    })
    if (res) {
      this.visitFee = this.receiptPreview.visitFee
      this.otherFee = this.receiptPreview.otherFee
      this.minimumAmountFreeShip = this.receiptPreview.minimumAmountFreeShip
      this.salesTax = this.receiptPreview.salesTaxValue
      this.shippingFee = this.receiptPreview.shippingFeeValue
      this.priceModifier = this.receiptPreview.priceModifierPercent
      this.$emit('updateOrderMethod', { code: this.receiptPreview.orderType.code, name: this.receiptPreview.orderType.name })
    }
  },
  computed: {
    ...mapState({
      visit: state => state.visits?.visit,
      result: state => state.results?.results
    }),
    ...mapState('receipts', {
      regularProductsItems (state) {
        return state?.receiptsPreview?.record?.regularProducts?.$values || []
      },
      clinicProductsItems (state) {
        return state?.receiptsPreview?.record?.clinicProducts?.$values
      },
      receiptPreview (state) {
        return state?.receiptsPreview?.record
      },
      listReceipts (state) {
        return state?.listReceipts?.$values
      },
      orderTypeName (state) {
        return state?.receiptsPreview?.record?.orderType?.name || ''
      }
    }),
    actions () {
      return [
        { icon: 'mdi-pencil', color: 'primary', name: 'Edit', action: this.editResult },
        { icon: 'mdi-trash-can-outline', color: 'red', name: 'Delete', action: this.deleteResult }
      ]
    },
    dialogs () {
      return this.$store.state.dialogs
    },
    headersClinicProducts() {
      return[
        {
          "text": "",
          "sortable": false,
          "filterable": false,
          "width": '60px',
          "value": "showOnReceipt",
          "type": "String"
        },
        {
          "text": "",
          "sortable": false,
          "filterable": false,
          "width": '110px',
          "value": "productNumber",
          "type": "String"
        },
        {
          "text": "",
          "sortable": false,
          "filterable": false,
          "width": '70px',
          "value": "quantity",
          "type": "String"
        },
        {
          "text": "",
          "sortable": false,
          "filterable": false,
          "value": "productName",
          "type": "String"
        },
        {
          "text": "",
          "sortable": false,
          "filterable": false,
          "value": "pastReceipt",
          "type": "String"
        },
        {
          "text": "",
          "sortable": false,
          "filterable": false,
          "width": '90px',
          "value": "unitPrice",
          "type": "String"
        },
        {
          "text": "",
          "sortable": false,
          "filterable": false,
          "width": '90px',
          "value": "totalCost",
          "type": "String"
        }
      ]
    },
    headers() {
      return [
        {
          "sortable": false,
          "filterable": false,
          "isCheckbox": true,
          "width": '60px',
          "value": 'selectAll'
        },
        {
          "text": "Product Code",
          "sortable": false,
          "filterable": false,
          "width": '110px',
          "value": "productNumber",
          "type": "String"
        },
        {
          "text": "QTY",
          "sortable": false,
          "filterable": false,
          "width": '50px',
          "value": "quantity",
          "type": "String"
        },
        {
          "text": "Product Name",
          "sortable": false,
          "filterable": false,
          "value": "productName",
          "type": "String"
        },
        {
          "text": "Past invoice",
          "sortable": false,
          "filterable": false,
          "value": "pastReceipt",
          "type": "String"
        },
        {
          "text": "Size",
          "sortable": false,
          "filterable": false,
          "value": "size",
          "type": "String"
        },
        {
          "text": "Unit Price",
          "sortable": false,
          "filterable": false,
          "width": '90px',
          "value": "unitPrice",
          "type": "String"
        },
        {
          "text": "Total Price",
          "sortable": false,
          "filterable": false,
          "width": '90px',
          "value": "totalCost",
          "type": "String"
        }
      ]
    }
  },
  watch: {
    allSelected(val) {
      if (this.silentUpdate) return
      this.regularProductsItems.forEach(item => {
        item.showOnReceipt = val
        this.updatePreviewReceipt('regularProducts', item, item.resultSupplementProductId, val)
      })
    },
    regularProductsItems: {
      handler(items) {
        const allChecked = items.length > 0 && items.every(item => item.showOnReceipt)
        this.silentUpdate = true
        this.allSelected = allChecked
        this.$nextTick(() => {
          this.silentUpdate = false
        })
      },
      deep: true
    },
    async hidePricingOnReceipt (val) {
      if (val) {
        const { id } = this.$route.params
        const resultId = this.visit.resultId
        const orderMethodCode = this.orderMethod.code
        // const calcMethodCode = this.calcMethod.code
        const visitFee = this.visitFee
        const otherFee = this.otherFee
        const res = await this.createReceiptPreview(
          {
            form: {
              visitId: id,
              resultId,
              orderMethodCode,
              // calcMethodCode,
              visitFee,
              otherFee
            }
          })
        if (res) {
          this.visitFee = this.receiptPreview.visitFee
          this.otherFee = this.receiptPreview.otherFee
          this.minimumAmountFreeShip = this.receiptPreview.minimumAmountFreeShip
          this.salesTax = this.receiptPreview.salesTaxValue
          this.shippingFee = this.receiptPreview.shippingFeeValue
          this.priceModifier = this.receiptPreview.priceModifierPercent
        }
      }
    },
    async visitFee (val) {
      if (val) {
        const { id } = this.$route.params
        const resultId = this.visit.resultId
        const orderMethodCode = this.orderMethod.code
        // const calcMethodCode = this.calcMethod.code
        const otherFee = this.otherFee
        const res = await this.createReceiptPreview(
          {
            form: {
              visitId: id,
              resultId,
              visitFee: val,
              orderMethodCode,
              // calcMethodCode,
              otherFee
            }
          })
        if (res) {
          // this.visitFee = this.receiptPreview.visitFee
          this.otherFee = this.receiptPreview.otherFee
          this.minimumAmountFreeShip = this.receiptPreview.minimumAmountFreeShip
          this.salesTax = this.receiptPreview.salesTaxValue
          this.shippingFee = this.receiptPreview.shippingFeeValue
          this.priceModifier = this.receiptPreview.priceModifierPercent
        }
      }
    },
    async otherFee (val) {
      if (val) {
        const { id } = this.$route.params
        const resultId = this.visit.resultId
        const orderMethodCode = this.orderMethod.code
        // const calcMethodCode = this.calcMethod.code
        const visitFee = this.visitFee
        const res = await this.createReceiptPreview(
          {
            form: {
              visitId: id,
              resultId,
              otherFee: val,
              orderMethodCode,
              // calcMethodCode,
              visitFee
            }
          })
        if (res) {
          this.visitFee = this.receiptPreview.visitFee
          // this.otherFee = this.receiptPreview.otherFee
          this.minimumAmountFreeShip = this.receiptPreview.minimumAmountFreeShip
          this.salesTax = this.receiptPreview.salesTaxValue
          this.shippingFee = this.receiptPreview.shippingFeeValue
          this.priceModifier = this.receiptPreview.priceModifierPercent
        }
      }
    },
    async 'isUpdateDaysSupply' (val) {
      if (val) {
        const { id } = this.$route.params
        const resultId = this.visit.resultId
        // const calcMethodCode = this.calcMethod.code
        const visitFee = this.visitFee
        const otherFee = this.otherFee
        const orderMethodCode = this.orderMethod.code

        const res = await this.createReceiptPreview(
          {
            form: {
              visitId: id,
              resultId,
              // calcMethodCode,
              orderMethodCode,
              visitFee,
              otherFee
            }
          })
        if (res) {
          this.visitFee = this.receiptPreview.visitFee
          this.otherFee = this.receiptPreview.otherFee
          this.minimumAmountFreeShip = this.receiptPreview.minimumAmountFreeShip
          this.salesTax = this.receiptPreview.salesTaxValue
          this.shippingFee = this.receiptPreview.shippingFeeValue
          this.priceModifier = this.receiptPreview.priceModifierPercent
        }
        this.$emit('updateIsUpdateDaysSupply', false)
      }
    },
    async 'isUpdateVisit' (val) {
      if (val) {
        const { id } = this.$route.params
        const resultId = this.visit.resultId
        const visitFee = this.visitFee
        const otherFee = this.otherFee
        const orderMethodCode = this.orderMethod.code
        // const calcMethodCode = this.calcMethod.code
        const res = await this.createReceiptPreview(
          {
            form: {
              visitId: id,
              resultId,
              visitFee,
              otherFee,
              orderMethodCode,
              // calcMethodCode,
            }
          })
        if (res) {
          this.visitFee = this.receiptPreview.visitFee
          this.otherFee = this.receiptPreview.otherFee
          this.minimumAmountFreeShip = this.receiptPreview.minimumAmountFreeShip
          this.salesTax = this.receiptPreview.salesTaxValue
          this.shippingFee = this.receiptPreview.shippingFeeValue
          this.priceModifier = this.receiptPreview.priceModifierPercent
          this.$emit('updateIsUpdateVisit', false)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.receipt {
  padding-bottom: 50px;
  min-height: 100px;

  &-container {
    display: flex;
    justify-content: space-between;
    column-gap: 30px
  }

  &__column {

    & + .receipt__column {
      margin-top: 35px;
    }

    .info-title {
      font-weight: 600;
      font-size: 18px;
      color: #1A202C;
      margin-bottom: 0;
    }

    .card-title {
      font-size: 12px;
      font-weight: 500;
      color: #718096;
      text-transform: uppercase;
      margin-bottom: 13px;
    }

    ::v-deep {
      .v-card {
        box-shadow: 0px 10px 20px 0px #7180960F !important;
      }

      .table:not(.table-total-cost) {
        overflow-y: auto;
        max-height: 52vh;

        .v-data-table {
          background-color: transparent !important;

          .v-data-table__wrapper {
            table {
              td + td:not(.total-row) {
                &:nth-child(n + 3) {
                  border-left: 1px solid #EDF2F7 !important;
                }
              }
            }
            .v-data-table-header {
              tr {
                th {
                  color: #8492A6;
                  font-size: 10px;
                  font-weight: 600;
                  letter-spacing: 0.6px;
                  text-transform: uppercase;
                  border-bottom: 1px solid #EDF2F7;
                  padding: 0 4px!important;

                  &:nth-child(n + 3) {
                    border-left: 1px solid #EDF2F7 !important;
                  }

                  div {
                    justify-content: center!important;
                    float: unset!important;
                  }
                }
              }
            }

            tr {
              height: 52px;

              td {
                color: #1A202C;
                font-size: 15px;
                font-weight: 400;
                border-bottom: 1px solid #EDF2F7;

                .checkbox {
                  color: green;
                  .v-icon.v-icon {
                    color: #C9CED6;
                  }
                }
              }
            }
          }
        }

        ::v-deep .v-menu {
          .v-menu__content {
            z-index: 100!important;
          }
        }
      }
      .table.table-clinic-products {
        .v-data-table-header {
          visibility: hidden;
          height: 0;
          tr {
            height: 0 !important;
            th {
              height: 0 !important;
              span {
                font-size: 0;
              }
            }
          }
        }
      }
      .table.table-total-cost {
        .v-data-table {
          filter: none;
          box-shadow: 0px 0px 1px 0px #0C1A4B3D;
          background-color: #F7FAFC !important;
          border-radius: 0 0 16px 16px;
          padding: 11px 16px 11px 20px;

          .v-data-table__wrapper {
            table > tr {
              height: 38px;
              display: flex;
              align-items: center;
              justify-content: space-between;

              .total-row {
                font-weight: 600;
                font-size: 12px;

                &__col {
                  border-right: 1px solid #EDF2F7;
                  padding: 9px 22px;
                }
              }
            }
          }
        }
      }
    }

    .options-adn-fees {
      padding: 15px 22px 22px !important;

      .table {
        padding: 0 0 0!important;
      }
    }

    .all-receipts {
      box-shadow: none !important;
      background-color: transparent;
      margin-top: 40px;

      &__top {
        display: flex;
        align-items: center;
        column-gap: 19px;
        margin-bottom: 18px;

        .image {
          width: 25px;
        }

        span {
          color: #718096;
          font-size: 12px;
          font-weight: 500;
          padding-left: 70px
        }
      }

      .empty-receipts-message {
        color: #718096;
        font-size: 14px;
        font-weight: 400;
        margin-top: 27px;
      }

      .receipt-list {
        display: flex;
        flex-direction: column;
        row-gap: 4px;
        max-height: 280px;
        overflow-y: auto;

        &::-webkit-scrollbar {
          width: 8px;
        }

        &::-webkit-scrollbar-thumb {
          border: 5px solid #E4ECF7;
          border-radius: 4px;
        }

        &::-webkit-scrollbar-track {
          background-color: #F7FAFC;
        }

        .receipt-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          column-gap: 17px;

          &__content {
            display: flex;
            justify-content: space-between;
            flex-grow: 1;
            border-radius: 8px;
            background-color: rgba(208, 220, 255, 0.3);
            padding: 14px;
            cursor: pointer;

            .image {
              width: 24px;
              height: 24px;
            }

            .receipt-number-name {
              color: #1A202C;
              font-weight: 600;
              font-size: 15px;
            }
          }

          .receipt-details {
            display: flex;
            align-items: center;
            column-gap: 15px;
            color: #1A202C;
            font-weight: 400;
            font-size: 15px;

            .image {
              width: 16px;
              height: 16px;
            }
          }
        }
      }
    }
  }

  .main-row {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    column-gap: 1rem;

    .btn-white {
      ::v-deep .v-btn {
        color: #008C89;
        font-size: 12px;
        font-weight: 600;
        line-height: 1;
        letter-spacing: 0;
        border-radius: 8px;
        background-color: transparent;
        border: 1px solid #008C89;
        padding: 12px 20px;

        .image {
          margin-right: 8px;
        }
      }
    }

    .logo {
      width: 26px;
    }

    .input-setting {
      ::v-deep .v-input {
        width: 55px!important;
        &__control {
          .v-text-field__details {
            display: none!important;
          }
          .v-input__slot {
            padding: 0 1px!important;
          }
          .v-input__prepend-inner {
            width: 16px!important;
            margin-top: -1px!important;
            padding-right: 0!important;
          }
        }
        &__icon {
          width: unset;
          .v-icon {
            font-size: 15px;
          }
        }
        input {
          text-align: center;
          font-size: 15px;
        }
      }
    }
    .checkbox-setting {
      ::v-deep .v-input {
        width: 42px!important;
        &__control {
          .v-text-field__details {
            display: none!important;
          }
          .v-input__slot {
            padding: 0 1px!important;
          }
        }
      }
    }
    .checkbox-setting .checkbox {
      width: 25px;
    }
  }
  .disabled {
    pointer-events: none;
  }

  .loading {
    height: 100%;
    min-height: 100px;
    position: absolute;
    width: 100%;
    top: 0;
    background: rgb(213 213 213 / 50%);
    border-radius: 16px;
  }
}
@media (max-width: 960px) {
  .receipt {
    &-container {
      flex-direction: column;
    }

    .receipt__column.column-right {
      display: flex;
      flex: 0 0 100% !important;
      margin-top: 13px;

      .options-adn-fees,
      .all-receipts {
        width: 50%;
      }

      .all-receipts {
        margin-left: 24px;
        margin-top: 15px;
      }
    }
  }
}
@keyframes moveXandSpin {
  from {
    transform: translateX(0px) rotate(0);
  }
  to {
    transform: translateX(570px) rotate(720deg);
  }
}
</style>
